import { useQuery } from 'react-query'
import { useNavigate, useParams } from 'react-router-dom'
import { joinAbsRoute } from 'src/common/utils'

import { QUERY_KEYS, ROUTES } from 'src/constants'
import { accountsService } from 'src/services/accounts.service'
import { DEFAULT_LANGUAGE_CODE } from 'src/components/languages/langauges-list/constants'
const useAccount = (locale?: string, id?: string) => {
  const { accountId } = useParams()
  const navigate = useNavigate()

  return useQuery(
    [QUERY_KEYS.ACCOUNT, accountId || id, locale ?? DEFAULT_LANGUAGE_CODE],
    async () => {
      return accountsService.getAccount(
        id ? id.trim() : accountId?.trim()!,
        locale ?? DEFAULT_LANGUAGE_CODE,
      )
    },
    {
      onSettled: (data) => {
        if (!data && accountId) {
          navigate(joinAbsRoute(ROUTES.ACCOUNTS))
        }
      },
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      enabled: !!id || !!accountId,
      refetchInterval: (data) => (data?.is_minting ? 6000 : false),
    },
  )
}

export { useAccount }
